import * as Yup from "yup";

export const courseValidation = Yup.object().shape({
  name: Yup.string()
    .required("وارد کردن نام الزامی است")
    .min(3, "نام حد اقل باید 3 حرفی باشد."),
});
